var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"GetWechatQrCode":_vm.GetWechatQrCode,"GetUserByPlat":_vm.GetUserByPlat,"UnBindWechat":_vm.UnBindWechat}})}
var staticRenderFns = []

export { render, staticRenderFns }